import api from '..'

const destroyLmsProfile = (id: number) => {
  return api.delete(`administration/lms_profiles/${id}`)
}

export default destroyLmsProfile
